<template>
  <div class="terminate-audit-dialog">
    <el-dialog v-dialog-drag :title="readonly ? '终止申请详情' : title" :visible.sync="showDialog" width="1000px" :destroy-on-close="true"
      :before-close="cancel" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 审核操作区域 -->
        <div class="section-card audit-section" v-if="!readonly">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <el-button size="small" type="success" icon="el-icon-check" @click="handle">确认审核</el-button>
          </div>
          <el-form label-width="130px" ref="form" :model="form" :rules="rules" class="audit-form">
            <el-form-item label="审核结果" prop="status">
              <el-radio v-model="form.status" label="SUCCESS">
                <i class="el-icon-success" style="color: #67c23a;"></i> 通过
              </el-radio>
              <el-radio v-model="form.status" label="DEFEAT">
                <i class="el-icon-error" style="color: #f56c6c;"></i> 驳回
              </el-radio>
            </el-form-item>
            <el-form-item label="驳回原因" prop="rejectionReason" v-if="form.status === 'DEFEAT'" style="width: 90%;">
              <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3 }" placeholder="请输入驳回原因"
                v-model="form.rejectionReason" clearable>
              </el-input>
            </el-form-item>
          </el-form>
        </div>

      <!-- 申请信息 -->
        <div class="section-card">
          <div class="section-header-bar">
            <div class="section-title"><i class="el-icon-info"></i> 申请信息</div>
          </div>
          <div class="tab-content">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">终止范围</span>
                <span class="detail-value">
                  <el-tag :type="dataChange.contractTerminateFlag ? 'danger' : 'warning'" size="small">{{
                    terminationRange }}</el-tag>
                </span>
              </div>
              <div class="detail-item" v-if="!dataChange.contractTerminateFlag">
                <span class="detail-label">新合同金额</span>
                <span class="detail-value"><span class="amount-text">{{ dataChange.contractAmount }}</span></span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">申请终止原因</span>
                <span class="detail-value">
                  <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3 }"
                    placeholder="请输入内容" v-model="dataChange.reasonForTermination" readonly>
                  </el-input>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 返样信息 -->
       <div class="section-card" v-if="Object.keys(dataChange?.returnSampleBo || {}).length > 0">
          <div class="section-header-bar" @click="toggleSection('returnSample')">
            <div class="section-title"><i class="el-icon-refresh-left"></i> 返样</div>
            <i :class="sectionOpen.returnSample ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.returnSample">
            <div class="detail-item">
              <span class="detail-label">是否返样</span>
              <span class="detail-value">{{ returnSampleFlag }}</span>
            </div>
            <div class="detail-item" v-if="dataChange?.returnSampleBo?.returnSampleFlag === true">
              <span class="detail-label">服务费(返样)</span>
              <span class="detail-value"><span class="amount-text">{{ returnSampleAmount }}</span></span>
            </div>
            <div class="detail-item full-width" v-if="returnReasonFlag">
              <span class="detail-label">金额为0原因</span>
              <span class="detail-value">{{ dataChange.returnSampleBo.reason }}</span>
            </div>
          </div>
        </div>
        <!-- 更多分析要求信息 -->
        <div class="section-card" v-if="Object.keys(dataChange?.moreAnalysisRequest || {}).length > 0">
          <div class="section-header-bar" @click="toggleSection('moreAnalysis')">
            <div class="section-title"><i class="el-icon-data-analysis"></i> 更多分析要求信息</div>
            <i :class="sectionOpen.moreAnalysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.moreAnalysis">
            <div class="detail-item"
              v-if="Object.keys(selectDetail.data?.moreAnalysisRequest || {}).includes('SENIOR_ANALYSIS')">
              <span class="detail-label">高级分析原金额</span>
              <span class="detail-value"><span class="amount-text">{{
                selectDetail.data?.moreAnalysisRequest['SENIOR_ANALYSIS'] }}</span></span>
            </div>
            <div class="detail-item"
              v-if="Object.keys(dataChange?.moreAnalysisRequest || {}).includes('SENIOR_ANALYSIS')">
              <span class="detail-label">高级分析现金额</span>
              <span class="detail-value"><span class="amount-text">{{ dataChange?.moreAnalysisRequest['SENIOR_ANALYSIS']
                  }}</span></span>
            </div>
            <div class="detail-item"
              v-if="Object.keys(selectDetail.data?.moreAnalysisRequest || {}).includes('CUSTOMIZED_ANALYSIS')">
              <span class="detail-label">个性化分析原金额</span>
              <span class="detail-value"><span class="amount-text">{{
                selectDetail.data?.moreAnalysisRequest['CUSTOMIZED_ANALYSIS'] }}</span></span>
            </div>
            <div class="detail-item"
              v-if="Object.keys(dataChange?.moreAnalysisRequest || {}).includes('CUSTOMIZED_ANALYSIS')">
              <span class="detail-label">个性化分析现金额</span>
              <span class="detail-value"><span class="amount-text">{{
                dataChange?.moreAnalysisRequest['CUSTOMIZED_ANALYSIS'] }}</span></span>
            </div>
          </div>
        </div>

        <!-- 申请终止项目 -->
        <div class="section-card" v-if="specificProjectType && specificProjectType.length > 0">
          <div class="section-header-bar">
            <div class="section-title"><i class="el-icon-s-order"></i> 申请终止项目</div>
          </div>
          <div>
            <project-info-dialog :terminate-flag="true" :table-data="specificProjectType"></project-info-dialog>
          </div>
        </div>

        <!-- 硬盘选购终止信息 -->
        <div class="section-card" v-if="hardDiskPurchaseChanges.length > 0">
          <div class="section-header-bar">
            <div class="section-title"><i class="el-icon-s-order"></i> 硬盘选购终止信息</div>
          </div>
          <div>
            <el-table class="hard-disk-table" :data="hardDiskPurchaseChanges" stripe
              :cell-style="{ padding: '10px 0', textAlign: 'center' }">
              <el-table-column prop="status" label="类型" align="center">
                <template slot-scope="scope">
                  <el-tag size="small" type="success" v-if="scope.row.status === 'unchanged'">未改动</el-tag>
                  <el-tag size="small" type="danger" v-else-if="scope.row.status === 'changed'">已改动</el-tag>
                  <el-tag size="small" type="info" v-else>已删除</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="hardDiskSize" label="硬盘大小" align="center"></el-table-column>
              <el-table-column prop="sampleCount" label="数量" align="center"></el-table-column>
              <el-table-column prop="originalAmount" label="项目原金额" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.originalAmount !== null && scope.row.originalAmount !== undefined ?
                    scope.row.originalAmount : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="finalAmount" label="最终结算金额" align="center">
                <template slot-scope="scope">
                  <span :class="{
                    'amount-changed': scope.row.status === 'changed',
                    'amount-deleted': scope.row.status === 'deleted'
                  }">
                    {{ scope.row.finalAmount !== null && scope.row.finalAmount !== undefined ? scope.row.finalAmount
                      : '-' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 合同信息 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('baseInfo')">
            <div class="section-title"><i class="el-icon-document"></i> 合同信息</div>
            <i :class="sectionOpen.baseInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.baseInfo">
            <div class="detail-item">
              <span class="detail-label">合同编号</span>
              <span class="detail-value"><span class="highlight-text">{{ selectDetail.data.contractNumber
                  }}</span></span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同名称</span>
              <span class="detail-value">{{ selectDetail.data.contractName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">销售</span>
              <span class="detail-value">{{ selectDetail?.data?.sales?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">有效期限</span>
              <span class="detail-value"><el-tag type="primary" size="small">{{ selectDetail.data.expirationDate + '年'
                  }}</el-tag></span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同拟定时间</span>
              <span class="detail-value">{{ selectDetail.data.contractDraftingDate }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同原金额</span>
              <span class="detail-value"><span class="amount-text">{{ selectDetail.data.contractAmount }}</span></span>
            </div>
            <div class="detail-item"
              v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(selectDetail.data.contractType)">
              <span class="detail-label">增值金额</span>
              <span class="detail-value">{{ selectDetail.data.addedAmount + ' (' +
                getProportion(selectDetail.data.contractAmount, selectDetail.data.addedAmount) + ')' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">客户联系人</span>
              <span class="detail-value">
                <span v-if="selectDetail.data?.customerContacts?.contactName" class="contact-text">{{
                  selectDetail.data.customerContacts.contactName }}</span>
                <el-tag v-else type="danger" size="small">系统内未找到</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方</span>
              <span class="detail-value">{{ selectDetail.data?.baseCompany?.companyName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方联系人</span>
              <span class="detail-value">{{ selectDetail.data?.trusteeContacts?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同分类</span>
              <span class="detail-value">
                <el-tag :type="getContractColor(selectDetail.data.contractType, 'tagType')" size="small" :style="{
                  color: getContractColor(selectDetail.data.contractType, 'color'),
                  'background-color': getContractColor(selectDetail.data.contractType, 'backgroundColor'),
                  'border-color': getContractColor(selectDetail.data.contractType, 'borderColor')
                }">
                  {{ getContractColor(selectDetail.data.contractType, 'name') }}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同类型</span>
              <span class="detail-value"><el-tag type="warning" size="small">{{ selectDetail.data.projectType
                  }}</el-tag></span>
            </div>
            <div class="detail-item" v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(selectDetail.data.projectType)">
              <span class="detail-label">样品处理方式</span>
              <span class="detail-value">{{ selectDetail.data.sampleManagement === 'RETURN_SAMPLE' ? '返样' : '暂存样品'
                }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建时间</span>
              <span class="detail-value">{{ selectDetail.data.createTime }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">签订地点</span>
              <span class="detail-value">{{ selectDetail.data.signingPlace }}</span>
            </div>
            <div class="detail-item" v-if="selectDetail.data.contractFilePath">
              <span class="detail-label">合同</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(selectDetail.data.id, 'contract')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(selectDetail.data.id, 'contract')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width" v-if="findProjectAnnexProject(selectDetail.data)">
              <span class="detail-label">需做的理化性质列表</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="downloadProjectAnnexFile(selectDetail.data.id, findProjectAnnexProject(selectDetail.data).projectMainTypeId)">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="previewProjectAnnexFile(selectDetail.data.id, findProjectAnnexProject(selectDetail.data).projectMainTypeId)">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ selectDetail.data.remark }}</span>
            </div>
          </div>
        </div>

        <!-- 分析要求 -->
        <div class="section-card"
          v-if="['预付款扣款（测序分析）', '测序分析'].includes(selectDetail.data.projectType) && selectDetail.data.contractType !== 'DEVELOPMENT'">
          <div class="section-header-bar" @click="toggleSection('analysis')">
            <div class="section-title"><i class="el-icon-data-analysis"></i> 分析要求</div>
            <i :class="sectionOpen.analysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.analysis">
            <div class="detail-item">
              <span class="detail-label">分析要求</span>
              <span class="detail-value">{{ analysisName }}</span>
            </div>
            <div class="detail-item"
              v-if="analysis.filter(item => Object.keys(selectDetail.data.moreAnalysisRequest).includes(item.label)).map(item => item.name).length">
              <span class="detail-label">更多分析要求</span>
              <span class="detail-value">{{ moreAnalysis }}</span>
            </div>
            <div class="detail-item" v-if="selectDetail.data.seniorAnalysisAnnex">
              <span class="detail-label">高级分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(selectDetail.data.id, 'senior')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(selectDetail.data.id, 'senior')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item" v-if="selectDetail.data.customizedAnalysisAnnex">
              <span class="detail-label">个性化分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(selectDetail.data.id, 'customized')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(selectDetail.data.id, 'customized')">预览</el-button>
                </div>
              </span>
            </div>
          </div>
        </div>



        <!-- 物料信息 -->
        <div class="section-card" v-if="flatMaterialTracking.length > 0">
          <div class="section-header-bar" @click="toggleSection('materials')">
            <div class="section-title"><i class="el-icon-s-order"></i> 物料信息</div>
            <i :class="sectionOpen.materials ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="change-data-wrapper" v-show="sectionOpen.materials">
            <el-table :data="flatMaterialTracking" stripe style="width: 100%" max-height="400"
              header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }"
              :span-method="materialSpanMethod">
              <el-table-column label="物料状态" align="center" min-width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.statusType" size="small">{{ scope.row.statusText }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="物料名称" align="center" min-width="180">
                <template slot-scope="scope">
                  <span class="material-name">{{ scope.row.materialName || findName(scope.row.materialId) || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="specs" label="物料规格" align="center" min-width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.specs || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="申领数量" align="center" min-width="120">
                <template slot-scope="scope">
                  <span class="quantity-text">{{ scope.row.number }} <span class="unit-text">支</span></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import FilePreview from "@/components/file/FilePreview.vue";
import {attachmentContract} from "@/api/dilivery/sales/contract";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import {auditInfo} from "@/api/dilivery/audit";
import {getContractColor} from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";
import { getProportion } from "@/utils/float_decimal";
import projectAnnexMixin from "@/mixins/projectAnnexMixin";
import detailCommonMixin from "@/mixins/detailCommonMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "TerminateAuditDialog",
  mixins: [projectAnnexMixin, detailCommonMixin],
  components: { ProjectInfoDialog, FilePreview, Loading },
  props: ['showDialog', 'selectDetail', 'readonly'],
  data() {
    return {
      title: '终止审核',
      loading:false,
      showFile: false,
      fileInfo: '',
      sectionOpen: {
        baseInfo: true,
        analysis: true,
        returnSample: true,
        materials: true,
        moreAnalysis: true,
      },
      analysis:[
        {label:'SENIOR_ANALYSIS',name:'高级分析'},
        {label:'STANDARD_ANALYSIS',name:'标准分析'},
        {label:'CUSTOMIZED_ANALYSIS',name:'个性化分析'},
      ],
      form: {
        id: '',
        status: '',
        rejectionReason: ''
      },
      specificProjectType:[],
      dataChange:{},
      rules: {
        status: [
          {required: true, message: '审核结果不能为空', trigger: 'change'}
        ],
        rejectionReason: [
          {required: true, message: '驳回原因不能为空', trigger: 'change'}
        ],
      }
    }
  },
  mounted() {
    this.getLexiconOptions()
  },
  computed:{
    terminationRange() {
      return this.dataChange.contractTerminateFlag ? '合同终止' : '实验终止';
    },
    moreAnalysis() {
      return this.analysis.filter(item => Object.keys(this.selectDetail.data.moreAnalysisRequest).includes(item.label)).map(item => item.name).join(',')
    },
    analysisName() {
      return this.analysis.find(item => item.label === this.selectDetail.data.analysisRequest).name
    },
    returnSampleFlag() {
      return this.dataChange?.returnSampleBo?.returnSampleFlag ? '是' : '否'
    },
    returnSampleAmount() {
      return this.dataChange?.returnSampleBo?.returnSampleAmount
    },
    returnReasonFlag() {
      return Number(this.dataChange?.returnSampleBo?.returnSampleAmount) === 0 && this.dataChange?.returnSampleBo?.returnSampleFlag === true && this.dataChange?.returnSampleBo?.returnSampleAmount !== ''
    },
    hardDiskPurchaseChanges() {
      const oldList = Array.isArray(this.selectDetail?.data?.hardDiskPurchaseInfo) ? this.selectDetail.data.hardDiskPurchaseInfo : []
      const newList = Array.isArray(this.dataChange?.hardDiskPurchaseInfo) ? this.dataChange.hardDiskPurchaseInfo : []
      const rows = []
      const remainingNew = [...newList]
      oldList.forEach(oldItem => {
        const newIndex = remainingNew.findIndex(newItem => newItem.hardDiskSize === oldItem.hardDiskSize)
        if (newIndex !== -1) {
          const newItem = remainingNew.splice(newIndex, 1)[0]
          const changed = Number(oldItem.projectAmount) !== Number(newItem.projectAmount) || Number(oldItem.sampleCount) !== Number(newItem.sampleCount)
          rows.push({
            status: changed ? 'changed' : 'unchanged',
            hardDiskSize: oldItem.hardDiskSize || '-',
            sampleCount: oldItem.sampleCount !== undefined && oldItem.sampleCount !== null ? oldItem.sampleCount : '-',
            originalAmount: oldItem.projectAmount !== undefined && oldItem.projectAmount !== null ? oldItem.projectAmount : '-',
            finalAmount: newItem.projectAmount !== undefined && newItem.projectAmount !== null ? newItem.projectAmount : 0
          })
        } else {
          rows.push({
            status: 'deleted',
            hardDiskSize: oldItem.hardDiskSize || '-',
            sampleCount: oldItem.sampleCount !== undefined && oldItem.sampleCount !== null ? oldItem.sampleCount : '-',
            originalAmount: oldItem.projectAmount !== undefined && oldItem.projectAmount !== null ? oldItem.projectAmount : '-',
            finalAmount: 0
          })
        }
      })
      remainingNew.forEach(newItem => {
        rows.push({
          status: 'changed',
          hardDiskSize: newItem.hardDiskSize || '-',
          sampleCount: newItem.sampleCount !== undefined && newItem.sampleCount !== null ? newItem.sampleCount : '-',
          originalAmount: '-',
          finalAmount: newItem.projectAmount !== undefined && newItem.projectAmount !== null ? newItem.projectAmount : 0
        })
      })
      return rows
    },
    flatMaterialTracking() {
      return this._buildFlatMaterialTracking(this.selectDetail?.data?.protectiveFluidMail, this.selectDetail?.data?.materials)
    },
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id
          this.dataChange = JSON.parse(newVal.dataChange)
          const ep = this.dataChange.experimentalProcessItems || {};
          this.specificProjectType = newVal.data.specificProjectType
            .filter(item => Object.keys(this.dataChange.projectMainTypeIdAmount || {}).includes(item.projectMainTypeId) || Object.keys(this.dataChange.diskTypesAmount || {}).includes(item.projectType) || Object.keys(ep).includes(item.projectMainTypeId))
            .map(item => {
              const pm = this.dataChange.projectMainTypeIdAmount || {};
              const dt = this.dataChange.diskTypesAmount || {};
              const hasPm = Object.prototype.hasOwnProperty.call(pm, item.projectMainTypeId);
              const hasDt = Object.prototype.hasOwnProperty.call(dt, item.projectType);
              const hasEp = Object.prototype.hasOwnProperty.call(ep, item.projectMainTypeId);
              let projectNewAmount;
              let settledExperimentalProcessItems;
              if (hasEp) {
                // 实验过程构成金额的项目：逐项展示结算明细，最终结算金额=各实验过程结算额之和
                settledExperimentalProcessItems = ep[item.projectMainTypeId] || [];
                projectNewAmount = settledExperimentalProcessItems.reduce((sum, it) => {
                  const amt = Number(it.experimentAmount);
                  return sum + (!isNaN(amt) && amt > 0 ? amt : 0);
                }, 0);
              } else {
                projectNewAmount = hasPm ? pm[item.projectMainTypeId] : (hasDt ? dt[item.projectType] : undefined);
              }
              return { ...item, projectStatus: 'APPLYING', projectNewAmount, settledExperimentalProcessItems }
            })
        }
      },
      immediate: true
    },
  },
  methods: {
    getProportion,
    getContractColor,
    async download(id, type) {
      await this.downloadContractAttachment(id, type)
    },
    async preview(id, type) {
      await this.previewContractAttachment(id, type)
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    
    handle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          auditInfo(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$emit('submit', 'confirm')
              if (this.form.status === 'SUCCESS') {
                this.$messageUi.success('已通过')
              } else {
                this.$messageUi.success('已驳回')
              }
              this.$store.commit('right/setChangeRed',true)
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.terminate-audit-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}










.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
  padding: 16px;
}

.tab-content {
  padding: 20px;
}


.section-card-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    color: #409eff;
  }
}

.info-descriptions {
  ::v-deep .el-descriptions__header {
    margin-bottom: 15px;
  }
}









.material-desc {
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.hard-disk-section {
  display: flex;
  justify-content: center;
}

.hard-disk-table {
  width: 100%;
}

.amount-changed {
  color: #f56c6c;
  font-weight: 500;
}

.amount-deleted {
  color: #c0c4cc;
}


</style>
